import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { auth } from "../lib/api";

export default function Login() {
  const { signIn, signUp } = useAuth();
  const navigate = useNavigate();
  const [providers, setProviders] = useState(null);
  const [providerError, setProviderError] = useState("");
  const [mode, setMode] = useState("in");
  const [otpSent, setOtpSent] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    fetch("/api/auth-providers", { cache: "no-store" })
      .then(async (response) => {
        const body = await response.json();
        if (!response.ok) throw new Error(body.error || "Opções adicionais indisponíveis.");
        if (active) setProviders(body.providers || {});
      })
      .catch((cause) => {
        if (active) setProviderError(cause.message || "Opções adicionais indisponíveis.");
      });
    return () => { active = false; };
  }, []);

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    setNotice("");
    try {
      if (mode === "otp") {
        if (!otpSent) {
          await auth("email-otp/send-verification-otp", { email, type: "sign-in" });
          setOtpSent(true);
          setNotice("Código enviado. Confira sua caixa de entrada.");
        } else {
          await auth("sign-in/email-otp", { email, otp });
          await navigate("/app");
        }
      } else if (mode === "forgot") {
        await auth("request-password-reset", { email, redirectTo: `${window.location.origin}/redefinir-senha` });
        setNotice("Se o e-mail estiver cadastrado, você receberá instruções para redefinir a senha.");
      } else if (mode === "up") {
        await signUp({ name, email, password });
        await navigate("/app");
      } else {
        await signIn(email, password);
        await navigate("/app");
      }
    } catch (cause) {
      setError(cause.message || "Não foi possível concluir o acesso.");
    } finally {
      setBusy(false);
    }
  }

  function changeMode(nextMode) {
    setMode(nextMode);
    setOtpSent(false);
    setError("");
    setNotice("");
  }

  const heading = mode === "up" ? "Criar acesso" : mode === "forgot" ? "Recuperar senha" : mode === "otp" ? "Entrar com código" : "Entrar";
  const emailEnabled = providers?.email !== false;
  const otpEnabled = providers?.emailOTP === true;
  const emailMode = ["in", "up", "forgot"].includes(mode);
  const activeMethodEnabled = mode === "otp" ? (providers === null || otpEnabled) : emailEnabled;

  return (
    <main className="pagina-login">
      <Link className="marca" to="/">DiárioMed</Link>
      <form className="cartao-login" onSubmit={submit}>
        <p className="sobretitulo">Área profissional</p>
        <h1>{heading}</h1>
        {providerError && <p className="notice" role="status">{providerError} O acesso por e-mail e senha continua disponível.</p>}
        {(emailEnabled && emailMode || mode === "otp" && (providers === null || otpEnabled)) && <label>E-mail<input type="email" required value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" /></label>}
        {mode === "up" && <label>Nome<input required value={name} onChange={(event) => setName(event.target.value)} autoComplete="name" /></label>}
        {emailEnabled && ["in", "up"].includes(mode) && <label>Senha<input type="password" minLength="8" required value={password} onChange={(event) => setPassword(event.target.value)} autoComplete={mode === "in" ? "current-password" : "new-password"} /></label>}
        {mode === "otp" && otpEnabled && otpSent && <label>Código de 6 dígitos<input inputMode="numeric" autoComplete="one-time-code" maxLength="6" required value={otp} onChange={(event) => setOtp(event.target.value)} /></label>}
        {!emailEnabled && !otpEnabled && <p className="erro" role="alert">Nenhuma forma de acesso está habilitada no momento.</p>}
        {error && <p className="erro" role="alert">{error}</p>}
        {notice && <p className="notice" role="status">{notice}</p>}
        {activeMethodEnabled && <button className="botao primario" disabled={busy}>{busy ? "Aguarde…" : mode === "up" ? "Criar conta" : mode === "forgot" ? "Enviar instruções" : mode === "otp" ? otpSent ? "Confirmar código" : "Enviar código" : "Entrar"}</button>}
        <div className="login-links">
          {mode === "in" && emailEnabled && <button className="botao-link" type="button" onClick={() => changeMode("forgot")}>Esqueci minha senha</button>}
          {mode === "in" && otpEnabled && <button className="botao-link" type="button" onClick={() => changeMode("otp")}>Entrar com código por e-mail</button>}
          {mode === "in" && providers?.public_signup === true && emailEnabled && <button className="botao-link" type="button" onClick={() => changeMode("up")}>Primeiro acesso? Criar conta</button>}
          {mode === "up" && <button className="botao-link" type="button" onClick={() => changeMode("in")}>Já tem acesso? Entrar</button>}
          {(mode === "forgot" || mode === "otp") && <button className="botao-link" type="button" onClick={() => changeMode("in")}>Voltar para entrar</button>}
          {providers === null && !providerError && <small>Carregando opções adicionais…</small>}
        </div>
      </form>
    </main>
  );
}
